<template>
    <modal-slider
        :show="show"
        max-width="xl"
        closeable="true"
        @close="close"
        type="right"
    >
        <div class="rounded-lg px-6 py-4">
            <div class="flex">
                <button
                    @click="close"
                    class="text-sm text-gray-400"
                    content="Fechar"
                >
                    <i class="p-2 fa-1_5x text-gray-800 fas fa-arrow-left"></i>
                </button>
                <h1 class="text-2xl font-bold text-gray-800">Filtros</h1>
            </div>
        </div>
        <div
            class="
        min-height-200
        px-6
        py-4
        overflow-y-auto
        flex flex-col
        justify-between
      "
            style="height: calc(100vh - 50px)"
        >
            <div>
                <search-filter
                    v-for="filter in filters"
                    v-show="filter.key !== 'type_movement'"
                    :config="filter"
                    :key="filter.key"
                    v-model="form[filter.key]"
                    :class="`mt-2 col-span-${filter.colSpan || 2} `"
                    class="w-full"
                    type="details"
                />
                <div
                    v-for="(filter, index) in filters"
                    :key="filter.key + index"
                >
                    <search-filter
                        v-if="filter.key === 'type_movement'"
                        :config="filter"
                        :class="`mt-2 col-span-${filter.colSpan || 2} `"
                        v-model="form[filter.key]"
                        class="w-full"
                        type="details"
                    />
                </div>
            </div>
            <div
                class="
          flex
          justify-between
          px-6
          py-3
          text-center
          right-0
          z-20
          rekative
          bottom-0
          mt-4
        "
            >
                <button
                    class="uppercase text-gray-800 border border-gray-200 font-bold py-3 px-6 rounded-md"
                    @click="reset"
                >
                    <i class="fas fa-eraser mr-1" /> Limpar
                </button>
                <button
                    class="uppercase bg-yellow-400 text-black text-sm py-3 px-6 rounded-md"
                    @click="apply"
                >
                    <i class="fas fa-filter text-black mr-1" /> Filtrar
                </button>
            </div>
        </div>
    </modal-slider>
</template>

<script>
import AutoComplete from "../../Jetstream/AutoComplete.vue";
import Label from "../../Jetstream/Label.vue";
import ModalSlider from "./ModalSlider.vue";
import SearchFilter from "./SearchFilter.vue";

export default {
    components: {
        ModalSlider,
        SearchFilter,
        Label,
        AutoComplete
    },
    props: {
        show: {
            default: false
        },
        maxWidth: {
            default: "2xl"
        },
        closeable: {
            default: true
        },
        filters: {
            default: () => []
        },
        form: {
            default: () => {}
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
        dateErrorMessage(){
            this.$toast.open({
                message:
                    "Data inicial não pode ser maior que a data final.",
                type: "error",
                duration: 3000,
                position: "top-right"
            });
        },
        apply() {
            this.form.page = 1;
            let validateAmount = this.form.amount;
            if (this.form.date_from > this.form.date_to) {
                return this.dateErrorMessage()
            }

            let hasError = false;
            for (let key in this.form) {
                if (this.form[key]?.from > this.form[key]?.to) {
                    this.dateErrorMessage()
                    hasError = true;
                    break;
                }
                if (this.form[key]?.number_to < this.form[key]?.number_from) {
                    hasError = true;
                    return this.$toast.open({
                        message:
                            "Valor inicial não pode ser maior que o valor final.",
                        type: "error",
                        duration: 3000,
                        position: "top-right"
                    });
                }
            }
            if (hasError) return;
            this.$emit("apply", this.form);
        },
        reset() {
            this.$emit("reset");
        }
    }
};
</script>
